import { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts'
import { Box } from '@mui/material'
import Grid from '@mui/material/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import axios from '@fuse/utils/axios'
import customColor from 'helper/common';
import useRouter from '@fuse/hooks/useRouter';
import { setCustomFilterData } from 'app/main/assets/store/filterParamsReducer';
import { useDispatch } from "react-redux";

function DashboardChart(props) {
  const [toggle, setToggle] = useState(true)
  const [toggleOne, setToggleOne] = useState(true)
  const [isLoadingForCategory, setIsLoadingForCategory] = useState(false)
  const [isLoadingForLocation, setIsLoadingForLocation] = useState(false)
  const router = useRouter()
  const dispatch = useDispatch();
  const getPercentWidth = (w, n, x) => {
    const percentWidth = Math.round((x / (w / n)) * 100)
    return `${percentWidth}%`
  }
  const [customFilterDataInput, setCustomFilterDataInput] = useState()

  const [columnChartOption, setColumnChartOption] = useState({
    series: [{
      name: 'Count',
      data: []
    }],
    options: {
      annotations: {
        points: [{
          x: 'Bananas',
          seriesIndex: 0,
          label: {
            offsetY: 0,
            style: {
              color: '#fff',
            },
          }
        }]
      },
      chart: {
        height: 350,
        type: 'bar',
        zoom: {
          enabled: false
        },
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        bar: {
          borderRadius: 10,
          distributed: true,
          dataLabels: {
            position: 'top',
          },
          //columnWidth: `${optimalColumnWidthPercent1} + "%"`
        }
      },
      legend: {
        show: false
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        width: 0
      },
      grid: {
        row: {
          colors: ['#fff']
        }
      },
      xaxis: {
        labels: {
          show: true,
          rotate: 0,
          enabled: false,
          style: {
            cssClass: 'apexcharts-xaxis-label',
          }
        },
        tooltip: {
          enabled: false
        },
        categories: [],
        tickPlacement: 'on'
      },
      yaxis: {
        title: {
          text: 'Asset Count',
          style: {
            fontSize: '10px',
            fontWeight: '500',
            fontFamily: 'Inter',
            color: '#98A2B3',
            lineHeight: '16px'
          },
        },
      },
      // fill: {
      //   colors: ['#ffd480', '#e6e6ff', '#ffbb99'],
      //   opacity: 1
      // }
    }
  })

  const [pieChartOption, setPieChartOption] = useState({
    // series: [],
    series: [44, 55, 13, 43, 22, 23, 34, 37],
    options: {
      chart: {
        width: 300,
        height: 300,
        type: 'pie',
        align: 'left',
        // offsetY:60,
        // offsetX:0,
        // offsetX: -120,
      },
      legend: {
        show: true,
          markers: {
            radius: 0,
          },
        // offsetY: -120,
        // offsetX: -180,
        position: 'right',
        horizontalAlign:'right',
        // itemMargin:{
        //   horizontal:40,
        //   vertical:50,
        // }
    },
    yaxis: {
      show: true,
      title: {
        text: 'Asset Count',
        style: {
          fontSize: '10px',
          fontWeight: '500',
          fontFamily: 'Inter',
          color: '#98A2B3',
          lineHeight: '16px'
        },
      },
    },
    // pie: {
    //   dataLabels: {
    //     offset: -50,
    //   }, 
    // },
      points: [{
        mouseEnter: undefined,
        mouseLeave: undefined,
        click: undefined,
        label: {
            borderColor: '#c2c2c2',
            borderWidth: 1,
            borderRadius: 2,
            text: undefined,
            textAnchor: 'middle',
            offsetX: 0,
            offsetY: -15,
            mouseEnter: undefined,
            mouseLeave: undefined,
            click: undefined,
            style: {
                background: 'red',
                color: '#777',
                fontSize: '12px',
                fontWeight: 400,
                fontFamily: undefined,
                cssClass: 'apexcharts-point-annotation-label',
                padding: {
                  left: 5,
                  right: 5,
                  top: 0,
                  bottom: 2,
                }
            },
        },
      }],
      labels: ['Team A', 'Team B', 'Team C', 'Team D', 'Team E', 'Team F', 'Team G', 'Team H'],
      series: [2, 2, 6],
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 280
          },
        }
      }],
    },
  })


  // Graph: 2
  const [columnChart2Option, setColumnChart2Option] = useState({
    series: [{
      name: 'Count',
      data: []
    }],
    options: {
      annotations: {
        points: [{
          x: 'Bananas',
          seriesIndex: 0,
          label: {
            offsetY: 0,
            style: {
              color: '#fff',
            },
          }
        }]
      },
      chart: {
        height: 350,
        type: 'bar',
        zoom: {
          enabled: false
        },
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        bar: {
          borderRadius: 10,
          distributed: true,
          dataLabels: {
            position: 'top',
          },
        }
      },
      legend: {
        show: false
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        width: 0
      },
      grid: {
        row: {
          colors: ['#fff']
        }
      },
      xaxis: {
        labels: {
          show: true,
          rotate: 0,
          enabled: false,
          style: {
            cssClass: 'apexcharts-xaxis-label',
          }
        },
        tooltip: {
          enabled: false
        },
        categories: [],
        tickPlacement: 'on'
      },
      yaxis: {
        title: {
          text: 'Asset Count',
          style: {
            fontSize: '10px',
            fontWeight: '500',
            fontFamily: 'Inter',
            color: '#98A2B3',
            lineHeight: '16px'
          },
        },
      },
      // fill: {
      //   colors: ['#ffd480', '#e6e6ff', '#ffbb99']
      // }
    }
  })

  const [pieChart2Option, setPieChart2Option] = useState({
    // series: [],
    series: [44, 55, 13, 43, 22, 23, 34, 37],
    options: {
      chart: {
        width: 300,
        height: 300,
        type: 'pie',
        align: 'left',
      },
      fill: {
        colors: ['#ffd480', '#e6e6ff', '#ffbb99'],

      },
      legend: {
        // offsetY: -120,
        // offsetX: 80,
        position: 'right',
        horizontalAlign:'right',
        show: true,
        markers: {
          radius: 0,
        },
        // itemMargin:{
        //   horizontal:40,
        //   vertical:50,
        // }
    },
      // labels: [],
      labels: ['Team A', 'Team B', 'Team C', 'Team D', 'Team E', 'Team F', 'Team G', 'Team H'],
      series: [2, 2, 6],
      colors: ['#ffd480', '#e6e6ff', '#ffbb99'],
      points: [{
        mouseEnter: undefined,
        mouseLeave: undefined,
        click: undefined,
        label: {
            borderColor: '#c2c2c2',
            borderWidth: 1,
            borderRadius: 2,
            text: undefined,
            textAnchor: 'middle',
            offsetX: 0,
            offsetY: -15,
            mouseEnter: undefined,
            mouseLeave: undefined,
            click: undefined,
            style: {
                background: 'red',
                color: '#777',
                fontSize: '12px',
                fontWeight: 400,
                fontFamily: undefined,
                cssClass: 'apexcharts-point-annotation-label',
                padding: {
                  left: 5,
                  right: 5,
                  top: 0,
                  bottom: 2,
                }
            },
        },
      }],
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 280
          },
        }
      }]
    },
  })

  function categoryGraph() {
    setIsLoadingForCategory(true)
    axios.get('/dashboard/asset-category-graph').then((res) => {
      
      const { series_data, series_labels } = res.data.data
      const percentWidth = getPercentWidth(250,10,series_data.length)
      const updatedArray = series_data.map(value => (value === 0 ? 0.01 : value));
      setColumnChartOption({
        ...columnChartOption,
        series: [{
          name: 'Count',
          data: updatedArray
        }],
        options: {
          ...columnChartOption.options,
          // color:[
          //   function custom({ value, seriesIndex, w }) {
          //     const randomColor = selectColor(seriesIndex* 50);
          //     return randomColor
          //   },
          // ],
          chart:{
            ...columnChartOption.options.chart,
            events: {
              dataPointSelection: function(event, chartContext, config) {
                setCustomFilterDataInput({Category:series_labels[config.dataPointIndex]})
                  // router.push(`/assets-list`)
              }
            },
          },
          plotOptions:{
            bar: {
              ...columnChartOption.options.plotOptions.bar,
            columnWidth: percentWidth,
            }
          },
          colors:customColor(series_data),
          fill: {
            colors: customColor(series_data)
          },
          xaxis: {
            ...columnChartOption.options.xaxis,
            categories: series_labels,
            labels: {
              // trim: true,
              // rotate: 0,
              style: {
                 cssClass: 'apexcharts-xaxis-label',
              },
              rotate: -55,
              rotateAlways: true,
              trim: true,
              hideOverlappingLabels: true,
              show: true,
              minHeight: 100,
              maxHeight: 100,
            }
          },
          tooltip: {
            custom({ series, seriesIndex,dataPointIndex, w }) {
						  return (
                `${'<div class="custom_apex_tooltip">' +
                '<div class="square" style="background-color: '}${w.globals.fill.colors[dataPointIndex] };"></div>` +
                `<span>` +
                `<span>${  series_labels[dataPointIndex] }</span>` + `: ${ 
                w.globals.initialSeries[seriesIndex].data[dataPointIndex] === 0.01 ? 0 : w.globals.initialSeries[seriesIndex].data[dataPointIndex]
                }</span>` +
                `</div>`
                );
						}
					}
        }
      })
      setPieChartOption({
        ...pieChartOption,
        series: series_data,
        
        options: {
          ...pieChartOption.options,
          labels: series_labels,
          chart: {
            ...pieChartOption.options.chart,
            events: {
              dataPointSelection: function (event, chartContext, config) {
                setCustomFilterDataInput({Category:series_labels[config.dataPointIndex]})
              }
            },
          },
          colors:customColor(series_data),
          fill: {
            colors: customColor(series_data)
          },
          tooltip: {
            custom({ series, seriesIndex, dataPointIndex, w }) {
              return (
                `${'<div class="custom_apex_tooltip">' +
                '<div class="square" style="background-color: '}${w.globals.fill.colors[seriesIndex] };"></div>` +
                `<span>` +
                `<span>${  w.globals.labels[seriesIndex] }</span>` + `: ${ 
                series[seriesIndex] 
                }</span>` +
                `</div>`
              );
            }
          }
        }
      })
    }).catch((err) => {
      console.log(err)
    }).finally(()=>{
      setIsLoadingForCategory(false)
    })
  }

  function locationGraph() {
    setIsLoadingForLocation(true)
    axios.get('/dashboard/asset-location-graph').then((res) => {
      const { series_data, series_labels } = res.data.data
      const percentWidth = getPercentWidth(250,10,series_data.length)
      setColumnChart2Option({
        ...columnChart2Option,
        series: [{
          name: 'Count',
          data: series_data
        }],
        options: {
          ...columnChart2Option.options,
          chart:{
            ...columnChartOption.options.chart,
            events:{
              click: (event, chartContext, config) => {
                if(series_data[config.dataPointIndex]){
                  setCustomFilterDataInput({Location:series_labels[config.dataPointIndex]})
                  // router.push(`/assets-list`)
                }
              }
            },
          },
          plotOptions:{
            bar: {
              ...columnChart2Option.options.plotOptions.bar,
            columnWidth: percentWidth,
            }
          },
          colors:customColor(series_data),
          fill: {
            colors: customColor(series_data)
          },
          xaxis: {
            ...columnChart2Option.options.xaxis,
            categories: series_labels,
            labels: {
              // trim: true,
              // rotate: 0,
               style: {
                cssClass: 'apexcharts-xaxis-label',
               },
              rotate: -55,
              rotateAlways: true,
              trim: true,
              hideOverlappingLabels: true,
              show: true,
              minHeight: 100,
              maxHeight: 100,
            },
          },
          tooltip: {
						custom({ series, seriesIndex, dataPointIndex, w }) {
						  return (
							`${'<div class="custom_apex_tooltip">' +
							'<div class="square" style="background-color: '}${  w.globals.fill.colors[dataPointIndex]  };"></div>` +
							`<span>` +
							`<span>${  series_labels[dataPointIndex] }</span>` + `: ${ 
							w.globals.initialSeries[seriesIndex].data[dataPointIndex]
							}</span>` +
							`</div>`
						  );
						}
					},

        }
      })
      setPieChart2Option({
        ...pieChart2Option,
        series: series_data,
        options: {
          ...pieChart2Option.options,
          colors:customColor(series_data),
          fill: {
            colors: customColor(series_data)
          },
          labels: series_labels,
          chart: {
            ...pieChart2Option.options.chart,
            events: {
              dataPointSelection:
                  (event, chartContext, config) => {
                    setCustomFilterDataInput({ Location:series_labels[config.dataPointIndex]})
                  }
            },
          },
          tooltip: {
            custom({ series, seriesIndex, dataPointIndex, w }) {
              return (
                `${'<div class="custom_apex_tooltip">' +
                '<div class="square" style="background-color: '}${ w.globals.fill.colors[seriesIndex] };"></div>` +
                `<span>` +
                `<span>${  w.globals.labels[seriesIndex] }</span>` + `: ${ 
                series[seriesIndex] 
                }</span>` +
                `</div>`
              );
            }
          }
        }
      })
    }).catch((err) => {
      console.log(err)
    }).finally(()=>{
      setIsLoadingForLocation(false)
    })
  }

  useEffect(() => {
    categoryGraph()
    locationGraph()
  }, []);

  useEffect(() => {
    if(customFilterDataInput){
    dispatch(setCustomFilterData(customFilterDataInput))
    router.push(`/assets-list`)
    }
  },[customFilterDataInput])

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          {!isLoadingForCategory &&
            <Card className='card_chartBox translate-20-holder' style={{ marginRight: '5px' }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', padding: '13px' }}>
                <div className='assets_statusText'>
                  <h5>Assets By Category</h5>
                  <p>You can see all the assets data by category</p>
                </div>
                <div>
                  <span style={{ cursor: 'pointer' }} onClick={() => setToggle(!toggle)}>
                    {toggle ? <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.99963 3.97021V10.7202L3.14963 14.0952C2.75912 11.9874 3.13381 9.80937 4.20626 7.95321C5.27871 6.09705 6.97848 4.68464 8.99963 3.97021Z" fill="#F0D9F5" />
                      <path d="M9.37514 11.3699C9.48918 11.3041 9.58387 11.2094 9.6497 11.0953C9.71553 10.9813 9.75017 10.8519 9.75014 10.7202V3.97021C9.74947 3.85064 9.72022 3.73296 9.66483 3.62699C9.60944 3.52102 9.52951 3.42982 9.43171 3.36102C9.33392 3.29221 9.22109 3.24779 9.10263 3.23145C8.98418 3.21511 8.86353 3.22733 8.75076 3.26709C6.56168 4.04185 4.72075 5.57207 3.5589 7.58266C2.39706 9.59324 1.9905 11.9523 2.41232 14.2358C2.43419 14.3539 2.48409 14.465 2.55783 14.5598C2.63157 14.6546 2.72699 14.7303 2.83607 14.7805C2.93438 14.8265 3.04162 14.8502 3.15014 14.8499C3.28177 14.85 3.41111 14.8154 3.52514 14.7496L9.37514 11.3699ZM8.25014 5.10646V10.2871L3.76139 12.8774C3.75014 12.7358 3.75014 12.5933 3.75014 12.4546C3.75147 10.9343 4.17229 9.44387 4.96626 8.14738C5.76023 6.85089 6.89656 5.79863 8.25014 5.10646ZM20.4695 7.62834C20.4611 7.61146 20.4526 7.59365 20.4423 7.57678C20.432 7.5599 20.4236 7.54584 20.4133 7.53084C19.5536 6.06253 18.3249 4.8446 16.849 3.99797C15.3732 3.15134 13.7016 2.70546 12.0001 2.70459C11.8012 2.70459 11.6105 2.78361 11.4698 2.92426C11.3292 3.06491 11.2501 3.25568 11.2501 3.45459V12.0637L3.8617 16.3668C3.77596 16.4165 3.70092 16.4827 3.64092 16.5616C3.58092 16.6404 3.53715 16.7304 3.51213 16.8263C3.48711 16.9222 3.48134 17.0221 3.49516 17.1202C3.50898 17.2184 3.54211 17.3128 3.59264 17.398C4.67664 19.2439 6.33802 20.6818 8.32038 21.4897C10.3027 22.2976 12.4959 22.4307 14.5614 21.8684C16.6269 21.306 18.4499 20.0795 19.7491 18.3782C21.0483 16.6769 21.7515 14.5953 21.7501 12.4546C21.7523 10.7616 21.3108 9.09756 20.4695 7.62834ZM12.7501 4.23834C13.9396 4.34783 15.0912 4.71417 16.1253 5.31208C17.1594 5.90999 18.0515 6.72521 18.7398 7.70147L12.7501 11.1899V4.23834ZM12.0001 20.7046C10.6908 20.7012 9.40095 20.3879 8.23603 19.7902C7.07111 19.1925 6.06428 18.3274 5.29795 17.2658L12.3667 13.1493L12.3873 13.1362L19.4908 8.99896C20.0706 10.2559 20.3248 11.6385 20.23 13.0195C20.1352 14.4005 19.6945 15.7354 18.9484 16.9014C18.2023 18.0673 17.1748 19.0268 15.9605 19.6914C14.7463 20.356 13.3844 20.7045 12.0001 20.7046Z" fill="#562658" />
                    </svg>
                      :
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.5 3.75V19.5H14.25V3.75H19.5Z" fill="#F0D9F5" />
                        <path d="M21 18.75H20.25V3.75C20.25 3.55109 20.171 3.36032 20.0303 3.21967C19.8897 3.07902 19.6989 3 19.5 3H14.25C14.0511 3 13.8603 3.07902 13.7197 3.21967C13.579 3.36032 13.5 3.55109 13.5 3.75V7.5H9C8.80109 7.5 8.61032 7.57902 8.46967 7.71967C8.32902 7.86032 8.25 8.05109 8.25 8.25V12H4.5C4.30109 12 4.11032 12.079 3.96967 12.2197C3.82902 12.3603 3.75 12.5511 3.75 12.75V18.75H3C2.80109 18.75 2.61032 18.829 2.46967 18.9697C2.32902 19.1103 2.25 19.3011 2.25 19.5C2.25 19.6989 2.32902 19.8897 2.46967 20.0303C2.61032 20.171 2.80109 20.25 3 20.25H21C21.1989 20.25 21.3897 20.171 21.5303 20.0303C21.671 19.8897 21.75 19.6989 21.75 19.5C21.75 19.3011 21.671 19.1103 21.5303 18.9697C21.3897 18.829 21.1989 18.75 21 18.75ZM15 4.5H18.75V18.75H15V4.5ZM9.75 9H13.5V18.75H9.75V9ZM5.25 13.5H8.25V18.75H5.25V13.5Z" fill="#562658" />
                      </svg>
                    }
                  </span>
                </div>
              </Box>
              <hr style={{ margin: '0px' }} />
              <CardContent>
                {!isLoadingForCategory && 
                <div style={{position:'relative'}}>
                  {/* toggle ? */}<div className='chart_height' style={{ display: toggle ? 'block' : 'none' }} id="chart">
                    <div>
                    <ReactApexChart id="myChart"
                      series={columnChartOption.series}
                      options={columnChartOption.options} type="bar" height={300}
                    />
                  </div>
                  <Box sx={{ display: "flex", justifyContent: 'center', alignItems: 'center' }}>
                          <div style={{padding: '6px 8px'}} className='chart_button'>
                          Category
                          </div>
                  </Box>
                  </div>
                  {/* : */}
                  {/* {pieChartOption.map((tab, index) => ( */}

                  {/* <div>{pieChartOption.options}</div> */}

                  {/* ))} */}
                  <div style={{ display: !toggle ? 'block' : 'none' }}>
                    <div>
                    <ReactApexChart series={pieChartOption.series}
                      options={pieChartOption.options} type="pie" width="100%" height={300} className="pie_chart" />
                  </div>
                  <Box className='chart_btn_holder'>
                    <div style={{padding: '6px 8px', width: 'fit-content'}} className='chart_button'>
                      Category
                    </div>
                  </Box>
                  </div>
                  {/* } */}
                </div>
                }
                {/* <Box sx={{ display: "flex", justifyContent: 'center', alignItems: 'center' }}>
                  <Button className='chart_button'>
                    Category
                  </Button>
                </Box> */}
              </CardContent>
            </Card>
          }
        </Grid>
        <Grid item xs={6}>
        {!isLoadingForLocation &&
          <Card className='card_chartBox translate-20-holder'>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', padding: '13px' }}>
              <div className='assets_statusText'>
                <h5>Assets By Location</h5>
                <p>You can see all the assets data by location</p>
              </div>
              <div>
                <span style={{ cursor: 'pointer' }} onClick={() => setToggleOne(!toggleOne)}>
                  {toggleOne ? <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.99963 3.97021V10.7202L3.14963 14.0952C2.75912 11.9874 3.13381 9.80937 4.20626 7.95321C5.27871 6.09705 6.97848 4.68464 8.99963 3.97021Z" fill="#F0D9F5" />
                    <path d="M9.37514 11.3699C9.48918 11.3041 9.58387 11.2094 9.6497 11.0953C9.71553 10.9813 9.75017 10.8519 9.75014 10.7202V3.97021C9.74947 3.85064 9.72022 3.73296 9.66483 3.62699C9.60944 3.52102 9.52951 3.42982 9.43171 3.36102C9.33392 3.29221 9.22109 3.24779 9.10263 3.23145C8.98418 3.21511 8.86353 3.22733 8.75076 3.26709C6.56168 4.04185 4.72075 5.57207 3.5589 7.58266C2.39706 9.59324 1.9905 11.9523 2.41232 14.2358C2.43419 14.3539 2.48409 14.465 2.55783 14.5598C2.63157 14.6546 2.72699 14.7303 2.83607 14.7805C2.93438 14.8265 3.04162 14.8502 3.15014 14.8499C3.28177 14.85 3.41111 14.8154 3.52514 14.7496L9.37514 11.3699ZM8.25014 5.10646V10.2871L3.76139 12.8774C3.75014 12.7358 3.75014 12.5933 3.75014 12.4546C3.75147 10.9343 4.17229 9.44387 4.96626 8.14738C5.76023 6.85089 6.89656 5.79863 8.25014 5.10646ZM20.4695 7.62834C20.4611 7.61146 20.4526 7.59365 20.4423 7.57678C20.432 7.5599 20.4236 7.54584 20.4133 7.53084C19.5536 6.06253 18.3249 4.8446 16.849 3.99797C15.3732 3.15134 13.7016 2.70546 12.0001 2.70459C11.8012 2.70459 11.6105 2.78361 11.4698 2.92426C11.3292 3.06491 11.2501 3.25568 11.2501 3.45459V12.0637L3.8617 16.3668C3.77596 16.4165 3.70092 16.4827 3.64092 16.5616C3.58092 16.6404 3.53715 16.7304 3.51213 16.8263C3.48711 16.9222 3.48134 17.0221 3.49516 17.1202C3.50898 17.2184 3.54211 17.3128 3.59264 17.398C4.67664 19.2439 6.33802 20.6818 8.32038 21.4897C10.3027 22.2976 12.4959 22.4307 14.5614 21.8684C16.6269 21.306 18.4499 20.0795 19.7491 18.3782C21.0483 16.6769 21.7515 14.5953 21.7501 12.4546C21.7523 10.7616 21.3108 9.09756 20.4695 7.62834ZM12.7501 4.23834C13.9396 4.34783 15.0912 4.71417 16.1253 5.31208C17.1594 5.90999 18.0515 6.72521 18.7398 7.70147L12.7501 11.1899V4.23834ZM12.0001 20.7046C10.6908 20.7012 9.40095 20.3879 8.23603 19.7902C7.07111 19.1925 6.06428 18.3274 5.29795 17.2658L12.3667 13.1493L12.3873 13.1362L19.4908 8.99896C20.0706 10.2559 20.3248 11.6385 20.23 13.0195C20.1352 14.4005 19.6945 15.7354 18.9484 16.9014C18.2023 18.0673 17.1748 19.0268 15.9605 19.6914C14.7463 20.356 13.3844 20.7045 12.0001 20.7046Z" fill="#562658" />
                  </svg>
                    :
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M19.5 3.75V19.5H14.25V3.75H19.5Z" fill="#F0D9F5" />
                      <path d="M21 18.75H20.25V3.75C20.25 3.55109 20.171 3.36032 20.0303 3.21967C19.8897 3.07902 19.6989 3 19.5 3H14.25C14.0511 3 13.8603 3.07902 13.7197 3.21967C13.579 3.36032 13.5 3.55109 13.5 3.75V7.5H9C8.80109 7.5 8.61032 7.57902 8.46967 7.71967C8.32902 7.86032 8.25 8.05109 8.25 8.25V12H4.5C4.30109 12 4.11032 12.079 3.96967 12.2197C3.82902 12.3603 3.75 12.5511 3.75 12.75V18.75H3C2.80109 18.75 2.61032 18.829 2.46967 18.9697C2.32902 19.1103 2.25 19.3011 2.25 19.5C2.25 19.6989 2.32902 19.8897 2.46967 20.0303C2.61032 20.171 2.80109 20.25 3 20.25H21C21.1989 20.25 21.3897 20.171 21.5303 20.0303C21.671 19.8897 21.75 19.6989 21.75 19.5C21.75 19.3011 21.671 19.1103 21.5303 18.9697C21.3897 18.829 21.1989 18.75 21 18.75ZM15 4.5H18.75V18.75H15V4.5ZM9.75 9H13.5V18.75H9.75V9ZM5.25 13.5H8.25V18.75H5.25V13.5Z" fill="#562658" />
                    </svg>
                  }
                </span>
              </div>
            </Box>
            <hr style={{ margin: '0px' }} />
            <CardContent>
              <div style={{position:'relative'}}>
                {/* {toggleOne ? */}<div className='chart_height' style={{ display: toggleOne ? 'block' : 'none' }} id="chart">
                  <div>
                  <ReactApexChart id="myChart"
                    series={columnChart2Option.series}
                    options={columnChart2Option.options} type="bar" height={300}
                  />
                </div>
                <Box sx={{ display: "flex", justifyContent: 'center', alignItems: 'center' }}>
                <div style={{padding: '6px 8px'}} className='chart_button'>
                  Location
                </div>
              </Box>
                </div>
                {/* : */}
                <div style={{ display: !toggleOne ? 'block' : 'none' }}>
                  <div>
                  <ReactApexChart series={pieChart2Option.series}
                    options={pieChart2Option.options} type="pie" width="100%" height={300} className="pie_chart" />
                </div>
                <Box className='chart_btn_holder'>
                  <div style={{padding: '6px 8px', width: 'fit-content'}} className='chart_button'>
                    Location
                  </div>
								</Box>
                </div>
                {/* } */}
              </div>
              {/* <Box sx={{ display: "flex", justifyContent: 'center', alignItems: 'center' }}>
                <Button className='chart_button'>
                  Location
                </Button>
              </Box> */}
            </CardContent>
          </Card>
        }
        </Grid>
      </Grid>
    </>
  );
}
export default DashboardChart